// extracted by mini-css-extract-plugin
export default {"body":"style_body__vilek","formbox":"style_formbox__wptPj","come":"style_come__xJM5G","email":"style_email__GvuJw","password":"style_password__BA5SV"};